// extracted by mini-css-extract-plugin
module.exports = {"blockQuote":"blockQuote_blockQuote__1aQTM","blockQuote__bulb":"blockQuote_blockQuote__bulb__FRRf_"};